import React, { useEffect } from "react";
import "./App.css";
import "./styles/mobile.css";
import "@/i18n";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ProductPage from "./pages/ProductPage";
import UseCasesPage from "./pages/UseCasesPage";
import IntegrationPage from "./pages/IntegrationPage";
import SecurityPage from "./pages/SecurityPage";
import ContactPage from "./pages/ContactPage";
import StablecoinPage from "./pages/StablecoinPage";
import AiAgentsPage from "./pages/AiAgentsPage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminPage from "./pages/AdminPage";
import MobileStickyCTA from "./components/MobileStickyCTA";
import { Toaster } from "./components/ui/sonner";

const MarketingShell = ({ children }) => {
  const location = useLocation();
  // Admin routes use their own chrome — skip the marketing header / footer / sticky CTA.
  const isAdmin = location.pathname.startsWith("/admin");

  // Lead-source attribution: record the last marketing page the user was on
  // BEFORE landing on /contacto. Also capture the original external referrer
  // (Google, LinkedIn, etc.) once per session.
  useEffect(() => {
    if (isAdmin) return;
    try {
      if (!sessionStorage.getItem("lead_initial_referrer")) {
        sessionStorage.setItem("lead_initial_referrer", document.referrer || "");
      }
      if (location.pathname !== "/contacto") {
        sessionStorage.setItem("lead_source_path", location.pathname);
      }
    } catch (_) {
      // sessionStorage can throw in restricted contexts (private mode iframes); fail silently.
    }
  }, [location.pathname, isAdmin]);

  if (isAdmin) return children;
  return (
    <>
      <Header />
      {children}
      <Footer />
      <MobileStickyCTA />
    </>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <MarketingShell>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/producto" element={<ProductPage />} />
              <Route path="/casos-de-uso" element={<UseCasesPage />} />
              <Route path="/integracion" element={<IntegrationPage />} />
              <Route path="/seguridad" element={<SecurityPage />} />
              <Route path="/contacto" element={<ContactPage />} />
              <Route path="/stablecoin" element={<StablecoinPage />} />
              <Route path="/ai-agents" element={<AiAgentsPage />} />
              <Route path="/admin/login" element={<AdminLoginPage />} />
              <Route path="/admin" element={<AdminPage />} />
            </Routes>
          </MarketingShell>
          <Toaster />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
